export enum EventAction {
  WebsiteClick = "website_click",
  WebsitePlay = "website_play",
  WebsiteShare = "website_share",
  WebsiteSend = "website_send",
}
